<div class="stepper-container">
  @if (selected) {
      <div>
          <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
      </div>
  }
</div>